import AccessoryCommon from "./accessoryCommon";
import {createParentPositions, SIDE_POSITIONS} from "../../constants";
import {Shower} from "../../parts/shower";

export default class Seats extends AccessoryCommon {
  constructor(isChild, partNumber = 0) {
    super(isChild);
    this.partNumber = partNumber;
    this.partId = 'shower_seats';
    this.partName = 'Seats';
    this.dbName = 'Seats';
    this.translateId = "visualizer.bathroom.accessories.shower_seats";
    this.visible = true;
    this.canBeDisabled = true;
    this.conflictingPositions = ["valve_trim"];
    if (isChild) {
      createParentPositions(this);
    }
  }

  load(dbFeature) {
    dbFeature.metaData["layerPosition"] = dbFeature.metaData["Side"] ? dbFeature.metaData["Side"][0] : "";
    const partNumber = dbFeature.metaData["layerPosition"] === SIDE_POSITIONS[0] ? 1 : 2;
    return super.load_(dbFeature, new Seats(false, partNumber),
      true, partNumber === 1 ? 'features' : 'featuresParts');
  }

  setLayers(layout) {
    const showerParent = this.getParent().layout.parts[Shower.id];
    if (showerParent && showerParent.showerTubComboIsActive()) { //  shower tub combo - remove
      super.hideLayers();
      return;
    }

    return super.setLayers(layout);
  }
  //
  // setZIndex(zIndexes) {
  //   if (zIndexes) {
  //     Object.keys(this.layerPositions).forEach((key, keyIndex) => {
  //       if (this.layerPositions[key]) {
  //         this.layerPositions[key].layer.zIndex = zIndexes.Accessories.Seats + keyIndex*10;
  //       }
  //     })
  //   }
  // }

  showLayerPositionsModal() {
    return true
  }

}
